import { TFunction } from 'i18next';
import { Profile } from '../../global-state/types';
import { isSupportedSuamRole, RoleMapping, Translation } from '../../utils';

export const getCurrentJobTitles = (
  profile: Profile,
  currentStoreId: string,
  t: TFunction,
  fallbackRoleLabel: Translation,
) => {
  const jobTitlesForStore = profile.jobTitles
    ?.find(({ storeId }) => storeId === currentStoreId)
    ?.jobTitles?.join(', ');

  if (jobTitlesForStore) {
    return jobTitlesForStore;
  }

  const assignmentTitles = profile.assignments
    ?.filter(({ locationCode }) => locationCode === currentStoreId)
    .map(({ title }) => title)
    .join(', ');

  if (assignmentTitles) {
    return assignmentTitles;
  }

  return profile.assignments
    ?.filter(({ locationCode }) => locationCode === currentStoreId)
    .map(({ suamRoleCode }) =>
      isSupportedSuamRole(suamRoleCode)
        ? t(`employees.roles.${RoleMapping[suamRoleCode]}`, RoleMapping[suamRoleCode])
        : fallbackRoleLabel,
    )
    .join(', ');
};

export const getHasOrganizationIdInAssignments = (profile: Profile) => {
  return (
    profile.assignments?.some(
      (assignment) => typeof assignment.organizationId === 'string' && assignment.organizationId.trim() !== '',
    ) ?? false
  );
};
